/* eslint-disable max-lines */
import React, { ReactElement, memo } from "react";

function Grinning(): ReactElement {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
                fill="url(#paint0_radial_1656_104677)"
            />
            <path
                d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
                fill="url(#paint1_radial_1656_104677)"
            />
            <path
                d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
                fill="url(#paint2_radial_1656_104677)"
                fillOpacity="0.6"
            />
            <path
                d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
                fill="url(#paint3_radial_1656_104677)"
            />
            <path
                d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
                fill="url(#paint4_radial_1656_104677)"
            />
            <path
                d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
                fill="url(#paint5_radial_1656_104677)"
            />
            <path
                d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
                fill="url(#paint6_radial_1656_104677)"
            />
            <path
                d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
                fill="url(#paint7_radial_1656_104677)"
            />
            <path
                d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
                fill="url(#paint8_radial_1656_104677)"
            />
            <path
                d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
                fill="url(#paint9_radial_1656_104677)"
            />
            <path
                d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
                fill="url(#paint10_radial_1656_104677)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.5 14.25C12.8472 14.25 14.75 12.3472 14.75 10C14.75 7.65279 12.8472 5.75 10.5 5.75C8.15279 5.75 6.25 7.65279 6.25 10C6.25 12.3472 8.15279 14.25 10.5 14.25ZM21.5 14.25C23.8472 14.25 25.75 12.3472 25.75 10C25.75 7.65279 23.8472 5.75 21.5 5.75C19.1528 5.75 17.25 7.65279 17.25 10C17.25 12.3472 19.1528 14.25 21.5 14.25Z"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.25 10C13.25 11.2426 12.2426 12.25 11 12.25C9.75736 12.25 8.75 11.2426 8.75 10C8.75 8.75736 9.75736 7.75 11 7.75C12.2426 7.75 13.25 8.75736 13.25 10ZM23.25 10C23.25 11.2426 22.2426 12.25 21 12.25C19.7574 12.25 18.75 11.2426 18.75 10C18.75 8.75736 19.7574 7.75 21 7.75C22.2426 7.75 23.25 8.75736 23.25 10Z"
                fill="url(#paint11_linear_1656_104677)"
            />
            <path
                d="M16 25C7 25 7 16 7 16H25C25 16 25 25 16 25Z"
                fill="url(#paint12_radial_1656_104677)"
            />
            <path
                d="M8 16.5V16H24V16.5C24 17.0523 23.5523 17.5 23 17.5H9C8.44772 17.5 8 17.0523 8 16.5Z"
                fill="url(#paint13_linear_1656_104677)"
            />
            <defs>
                <radialGradient
                    id="paint0_radial_1656_104677"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(25.5 9) rotate(131.878) scale(38.9487)"
                >
                    <stop stopColor="#FFF478" />
                    <stop offset="0.474827" stopColor="#FFB02E" />
                    <stop offset="1" stopColor="#F70A8D" />
                </radialGradient>
                <radialGradient
                    id="paint1_radial_1656_104677"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(16 12.5) rotate(101.31) scale(17.8466 22.8581)"
                >
                    <stop offset="0.787821" stopColor="#F59639" stopOpacity="0" />
                    <stop offset="0.972509" stopColor="#FF7DCE" />
                </radialGradient>
                <radialGradient
                    id="paint2_radial_1656_104677"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(18 14) rotate(135) scale(41.0122)"
                >
                    <stop offset="0.314853" stopOpacity="0" />
                    <stop offset="1" />
                </radialGradient>
                <radialGradient
                    id="paint3_radial_1656_104677"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(16 17) rotate(77.692) scale(28.1469)"
                >
                    <stop offset="0.507903" stopColor="#7D6133" stopOpacity="0" />
                    <stop offset="1" stopColor="#715B32" />
                </radialGradient>
                <radialGradient
                    id="paint4_radial_1656_104677"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(16.5 16.5) rotate(55.7131) scale(13.3135 9.65032)"
                >
                    <stop stopColor="#FFB849" />
                    <stop offset="1" stopColor="#FFB847" stopOpacity="0" />
                </radialGradient>
                <radialGradient
                    id="paint5_radial_1656_104677"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(20.5 18) rotate(9.86581) scale(11.6726)"
                >
                    <stop stopColor="#FFA64B" />
                    <stop offset="0.900412" stopColor="#FFAE46" stopOpacity="0" />
                </radialGradient>
                <radialGradient
                    id="paint6_radial_1656_104677"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(17.5 15) rotate(43.9708) scale(59.0529)"
                >
                    <stop offset="0.185425" stopOpacity="0" />
                    <stop offset="1" stopOpacity="0.4" />
                </radialGradient>
                <radialGradient
                    id="paint7_radial_1656_104677"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(8.5 10.5) rotate(83.6598) scale(4.52769 3.66439)"
                >
                    <stop offset="0.47452" stopColor="#B3671F" />
                    <stop offset="0.781916" stopColor="#B3671F" stopOpacity="0.236695" />
                    <stop offset="0.873485" stopColor="#B3671F" stopOpacity="0.0865443" />
                    <stop offset="0.948588" stopColor="#B3671F" stopOpacity="0" />
                </radialGradient>
                <radialGradient
                    id="paint8_radial_1656_104677"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(19.5 9.5) rotate(102.529) scale(4.60977 3.55208)"
                >
                    <stop offset="0.308886" stopColor="#D57B2A" />
                    <stop offset="0.773417" stopColor="#E28B30" stopOpacity="0.15" />
                    <stop offset="0.936131" stopColor="#E28B30" stopOpacity="0" />
                </radialGradient>
                <radialGradient
                    id="paint9_radial_1656_104677"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(10.605 10.6448) rotate(84.716) scale(4.07123)"
                >
                    <stop offset="0.359039" stopColor="#C84E28" />
                    <stop offset="1" stopColor="#C84528" stopOpacity="0" />
                </radialGradient>
                <radialGradient
                    id="paint10_radial_1656_104677"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(21.3381 10.5176) rotate(104.846) scale(4.30135)"
                >
                    <stop offset="0.359039" stopColor="#C84E28" />
                    <stop offset="1" stopColor="#C84528" stopOpacity="0" />
                </radialGradient>
                <linearGradient
                    id="paint11_linear_1656_104677"
                    x1="16.5"
                    y1="8"
                    x2="16.5"
                    y2="12"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#553B3E" />
                    <stop offset="1" stopColor="#3D2432" />
                </linearGradient>
                <radialGradient
                    id="paint12_radial_1656_104677"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(16 27) rotate(-90) scale(11 22)"
                >
                    <stop stopColor="#F70A8D" />
                    <stop offset="1" stopColor="#89029C" />
                </radialGradient>
                <linearGradient
                    id="paint13_linear_1656_104677"
                    x1="16"
                    y1="16"
                    x2="16"
                    y2="17.5"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#ECCDFF" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
            </defs>
        </svg>
    );
}

export default memo(Grinning);
